import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('how_would_you_like_to_authenticate_your_action'),
    appCodeRadio: defineMessage('authenticator_app'),
    emailCodeRadio: defineMessage('alternative_email_address'),
    backupCodeRadio: defineMessage('backup_code'),
    nextButton: defineMessage('proceed'),
    note: defineMessage('if_you_have_problems_re_port_articlesupportlink'),
};
